import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store'
import { GET_USER } from '../store/actions'

const HomePage = () => import(/* webpackChunkName: "HomePage" */ '@/components/pages/HomePage')
const ResultsPage = () =>
  import(/* webpackChunkName: "ResultsPage" */ '@/components/pages/ResultsPage')
const BucketPage = () =>
  import(/* webpackChunkName: "BucketPage" */ '@/components/pages/BucketPage')
const UserPage = () => import(/* webpackChunkName: "UserPage" */ '@/components/pages/UserPage')

const BucketsPage = () =>
      import(/* webpackChunkName: "BucketsPage" */ '@/components/pages/BucketsPage')

const UsersPage = () =>
      import(/* webpackChunkName: "UsersPage" */ '@/components/pages/UsersPage')

const PayingBuckets = () =>
      import(/* webpackChunkName: "UsersPage" */ '@/components/pages/PayingBuckets')

const CreateUserPage = () =>
  import(/* webpackChunkName: "CreateUserPage" */ '@/components/pages/CreateUserPage')
const CreateBucketPage = () =>
  import(/* webpackChunkName: "CreateBucketPage" */ '@/components/pages/CreateBucketPage')
const ListPurchaseOrdersPage = () =>
  import(/* webpackChunkName: "ListPurchaseOrdersPage" */ '@/components/pages/ListPurchaseOrdersPage')
const CreatePurchaseOrderPage = () =>
  import(/* webpackChunkName: "CreatePurchaseOrderPage" */ '@/components/pages/CreatePurchaseOrderPage')
const Pm2DownloadsPage = () =>
  import(/* webpackChunkName: "Pm2DownloadsPage" */ '@/components/pages/Pm2DownloadsPage')
const Pm2DownloadDetailsPage = () =>
  import(/* webpackChunkName: "Pm2DownloadDetailsPage" */ '@/components/pages/Pm2DownloadDetailsPage')
const TrialPage = () => import(/* webpackChunkName: "TrialPage" */ '@/components/pages/TrialPage')
const ChangelogPage = () =>
  import(/* webpackChunkName: "ChangelogPage" */ '@/components/pages/ChangelogPage')

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: HomePage
    },
    {
      path: '/results/:searchText',
      name: 'Results',
      component: ResultsPage
    },
    {
      path: '/bucket/:id',
      name: 'Bucket',
      component: BucketPage
    },
    {
      path: '/users',
      name: 'Users',
      component: UsersPage
    },
    {
      path: '/user/:id',
      name: 'User',
      component: UserPage
    },
    {
      path: '/buckets',
      name: 'Buckets',
      component: BucketsPage
    },
    {
      path: '/payingbuckets',
      name: 'PayingBuckets',
      component: PayingBuckets
    },
    {
      path: '/create-user',
      name: 'Create user',
      component: CreateUserPage
    },
    {
      path: '/create-bucket',
      name: 'Create bucket',
      component: CreateBucketPage
    },
    {
      path: '/purchase-orders/list',
      name: 'List purchase orders',
      component: ListPurchaseOrdersPage
    },
    {
      path: '/purchase-orders/create',
      name: 'Create purchase order',
      component: CreatePurchaseOrderPage
    },
    {
      path: '/purchase-orders/edit/:id',
      name: 'Edit purchase order',
      component: CreatePurchaseOrderPage
    },
    {
      path: '/pm2-downloads',
      name: 'PM2 downloads',
      component: Pm2DownloadsPage,
      beforeEnter () {
        window.location = `https://kibana.cloud.pm2.io/app/kibana#/visualize/edit/AWkv75PNZFb55X_5644_?_g=(refreshInterval:(display:Off,pause:!f,value:0),time:(from:now-1M%2FM,mode:quick,to:now-1M%2FM))&_a=(filters:!(),linked:!f,query:(query_string:(analyze_wildcard:!t,query:'certHttps.keyword:*.*')),uiState:(vis:(params:(sort:(columnIndex:!n,direction:!n)))),vis:(aggs:!((enabled:!t,id:'1',params:(),schema:metric,type:count),(enabled:!t,id:'3',params:(aggregate:concat,customLabel:Country,field:locationPlus.country.keyword,size:1,sortField:date,sortOrder:desc),schema:metric,type:top_hits),(enabled:!t,id:'4',params:(aggregate:concat,customLabel:Continent,field:locationPlus.continent.keyword,size:1,sortField:date,sortOrder:desc),schema:metric,type:top_hits),(enabled:!t,id:'5',params:(customLabel:Domain,field:certHttps.keyword,order:desc,orderBy:'1',size:200),schema:bucket,type:terms)),listeners:(),params:(perPage:20,showMeticsAtAllLevels:!f,showPartialRows:!f,showTotal:!f,sort:(columnIndex:!n,direction:!n),totalFunc:sum,type:table),title:'Export%20PM2%20Downloads%20Filtered',type:table))`
      }
    },
    {
      path: '/pm2-downloads/:cert',
      name: 'PM2 downloads details',
      component: Pm2DownloadDetailsPage
    },
    {
      path: '/trial',
      name: 'Trial',
      component: TrialPage
    },
    {
      path: '/changelog',
      name: 'Changelog',
      component: ChangelogPage
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (store.getters.user._id !== undefined) return next()

  store.dispatch(GET_USER).then(() => {
    return next()
  })
})

export default router
